/* eslint-disable */


import { blueGrey, grey } from '@material-ui/core/colors';

/**
 * Create styles for `<ErrorPage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<ErrorPage />` styles
 */
const errorPageStyles = ({ theme, isLight }) => {
  const errorBackgroundColor = isLight() ? blueGrey[500] : grey[700];
  return {
    content: {
      color: theme.palette.getContrastText(errorBackgroundColor),
    },
    divider: {
      marginTop: theme.spacing(1) * 2,
    },
    footer: {
      bottom: 0,
      left: 0,
      marginLeft: theme.spacing(1),
      position: `fixed`,
      right: 0,
    },
    paper: {
      backgroundColor: errorBackgroundColor,
      flexDirection: `column`,
      justifyContent: `left`,
      marginLeft: theme.spacing(1) * 2,
      marginRight: theme.spacing(1) * 2,
      marginTop: theme.spacing(1) * 2,
      padding: theme.spacing(1) * 2,
    },
    root: {},
  };
};

export default errorPageStyles;
